<template>
  <div class="layout-subcontainer">
    <h1 class="tit-h1">메뉴권한관리</h1>
    <div class="box-wrap ">
      <div class="box-ct d-flex">
        <div>
          <div class="form-inp sm ml-2">
            <v-select
                :items="dropItems"
                item-text="CD_NM"
                item-value="CD"
                outlined
                hide-details
                label="메뉴그룹"
                placeholder="선택"
                v-model="menuGroup"
            >
              <template v-slot:label>
                메뉴그룹
                <v-icon color="#EF9191">mdi-circle-small</v-icon>
              </template>
            </v-select>
          </div>
          <div class="form-inp sm ml-2">
            <v-select
                :items="dropItems2"
                item-text="CD_NM"
                item-value="CD"
                outlined
                hide-details
                label="권한그룹"
                placeholder="선택"
                v-model="atrtGroupId"
            >
              <template v-slot:label>
                권한그룹
                <v-icon color="#EF9191">mdi-circle-small</v-icon>
              </template>
            </v-select>
          </div>
        </div>
        <div class="ml-auto align-self-center" >
          <v-btn v-if="this.mixin_set_btn(this.$options.name, 'btnSearch')" outlined class="btn-etc2" v-on:click="getListOrNot" id="btnSearch">조회</v-btn>
          <!--권한그룹관리 팝업-->
          <v-btn 
            v-if="this.mixin_set_btn(this.$options.name, 'btnPopupAuthGroup')"
            outlined
            class="btn-default ml-3"
            @click="showDialog('M810703P01')"
          >권한그룹관리</v-btn>
        </div>
        <v-dialog max-width="1400" persistent v-if="dialogM810703P01" v-model="dialogM810703P01" :eager="true" content-class="square-modal">
          <dialog-M810703P01
              headerTitle="권한그룹관리"
              p01
              @hide="hideDialog('M810703P01')"
              @submit="submitDialog('M810703P01')"
          >
          </dialog-M810703P01>
        </v-dialog>
      </div>
    </div>
    <div class="d-flex">
      <!--미할당메뉴,할당메뉴 가로-->
      <div class="box-wrap flex-grow-1">
        <h2 class="tit-h2 d-flex">
          <div class="ml-auto">
            <v-btn v-if="this.mixin_set_btn(this.$options.name, 'btnSave1')" outlined class="btn-point ml-2" id="btnSave" v-on:click="common_confirm('저장하시겠습니까?',submitGrid1,'',null,'','done')">저장</v-btn>
          </div>
        </h2>
        <div class="box-ct d-flex">
          <div style="width: 47%">
            <span>미할당메뉴</span>
            <v-data-table
                dense
                height="530px"
                :headers="divGridNoAlloc"
                :items="divGridNoAllocDataText"
                item-key="MENU_ID"
                :item-class="isActiveRow1"
                hide-default-footer
                class="grid-default"
                :page.sync="divGridNoAllocPage"
                @page-count="divGridNoAllocPageCount = $event"
                :items-per-page="30"
                show-select
                fixed-header
                no-data-text="검색된 결과가 없습니다."
                v-model="selectedDivGridNoAllocList"
                v-on:click:row="getGrid1_ListSel"
            >
            </v-data-table>
            <div class="grid-paging text-center pt-2">
            </div>
            <p class="caption text-right">
              <strong class="clr-error">{{ divGridNoAllocDataText.length }}</strong
              >건의 미할당 메뉴가 검색되었습니다.
            </p>
          </div>
          <div class="btn-arrow-wrap-vertical">
            <div class="">
              <v-btn v-if="this.mixin_set_btn(this.$options.name, 'btnDelArrow1')" class="btn-arrow" plain small @click="moveLeft">
                <v-icon small class="svg-arrow-left"></v-icon>
              </v-btn>
              <v-btn v-if="this.mixin_set_btn(this.$options.name, 'btnAddArrow1')" class="btn-arrow" plain small @click="moveRight">
                <v-icon small class="svg-arrow-right"></v-icon>
              </v-btn>
            </div>
          </div>
          <div class="flex-grow-1">
            <span>할당메뉴</span>
            <v-data-table
                dense
                :headers="divGridAlloc"
                :items="divGridAllocDataText"
                :items-per-page="30"
                item-key="MENU_ID"
                :item-class="isActiveRow3"
                :page.sync="divGridAllocPage"
                hide-default-footer
                show-select
                fixed-header
                class="grid-default"
                height="530px"
                @page-count="divGridAllocPageCount = $event"
                no-data-text="검색된 결과가 없습니다."
                v-model="selectedDivGridAllocList"
                v-on:click:row="getListSel"
            >
            </v-data-table>
            <div class="grid-paging text-center pt-2">
            </div>
            <p class="caption text-right">
              <strong class="clr-error">{{ divGridAllocDataText.length }}</strong
              >건의 할당 메뉴가 검색되었습니다.
            </p>
          </div>
        </div>
      </div>
      <div class="box-wrap col-4">
        <h2 class="tit-h2 d-flex">

          <div class="ml-auto">
            <v-btn v-if="this.mixin_set_btn(this.$options.name, 'btnSave2')" outlined class="btn-point" id="btnSave03" v-on:click="common_confirm('저장하시겠습니까?',submitBtnGrid1,'',null,'','done')">저장</v-btn>
          </div>
        </h2>
        <div class="box-ct">
          <div>
            <span>할당버튼</span>
            <v-data-table
                dense
                :headers="divGridAllocBtn"
                :items="divGridAllocBtnDataText"
                :items-per-page="30"
                item-key="BTN_ID"
                :item-class="isActiveRow2"
                :page.sync="divGridAllocBtnPage"
                hide-default-footer
                class="grid-default"
                show-select
                fixed-header
                height="250"
                @page-count="divGridAllocBtnPageCount = $event"
                no-data-text="검색된 결과가 없습니다."
                v-model="selectedDivGridAllocBtnList"
                v-on:click:row="getGrid1_ListSel"
            >
            </v-data-table>
          </div>
          <div class="d-flex justify-center">
            <v-btn v-if="this.mixin_set_btn(this.$options.name, 'btnDelArrow2')" class="btn-arrow" plain small @click="moveUp" >
              <v-icon small class="svg-arrow-top"></v-icon>
            </v-btn>
            <v-btn v-if="this.mixin_set_btn(this.$options.name, 'btnAddArrow2')" class="btn-arrow ml-2" plain small @click="moveDown">
              <v-icon small class="svg-arrow-down"></v-icon>
            </v-btn>
          </div>
          <div class="flex-grow-1">
            <span>미할당버튼</span>
            <v-data-table
                dense
                :headers="divGridNoAllocBtn"
                :items="divGridNoAllocBtnDataText"
                :items-per-page="30"
                item-key="BTN_ID"
                :item-class="isActiveRow2"
                :page.sync="divGridNoAllocBtnPage"
                hide-default-footer
                class="grid-default"
                show-select
                fixed-header
                height="250"
                @page-count="divGridNoAllocBtnPageCount = $event"
                no-data-text="검색된 결과가 없습니다."
                v-model="selectedDivGridNoAllocBtnList"
                v-on:click:row="getGrid1_ListSel"
            >
            </v-data-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DialogM810703P01 from "./M810703P01.vue";
import api from "../../store/apiUtil";
import {mixin} from "@/mixin/mixin";
export default {
  name: "MENU_M810703", //name은 'MENU_' + 파일명 조합
  components: {
    DialogM810703P01,
  },
  mixins:[mixin],
  data() {
    return {
      dialogM810703P01: false, //권한그룹관리
      HEADERResult:'',
      DATAResult:'',
      HEADER_SERVICE:'',
      HEADER_TYPE:'BIZ_SERVICE',
      HEADER_GRID_ID:'',
      HEADER_ATRT_GROUP_ID:'',
      headers:{},
      sendData: {},
      URLData:'',
      atrtGroupId:'',
      menuGroup:'',
      menuNm:'',
      atrtGroupNm:'',
      menuId:'',
      dataFlag:'',
      btnId:'',
      scrBtnNm:'',
      scrBtnId:'',
      selectedMenu:'',
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      timeStep: "10:10",
      timeStep2: "05:10",
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
      dates: [
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10),
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10),
      ],
      radioGroup: [
        {
          text: "고객접수시작",
        },
        {
          text: "고객접수중지",
        },
      ],
      radioGroupSelected: "고객접수시작",
      dropItems:[],
      dropItems2:[],
      divGridNoAlloc: [
        {
          text: "메뉴명",
          value: "MENU_NM",
          align: "left",
          sortable: true,
        },
      ],
      divGridAlloc: [
        {
          text: "권한그룹명",
          value: "ATRT_GROUP_NM",
          align: "center",
          sortable: false,
        },
        {
          text: "메뉴명",
          value: "MENU_NM",
          align: "left",
          sortable: true,
        }
      ],
      divGridNoAllocDataText: [],
      divGridNoAllocDataText2: [
        {
          index: 1,
          index01:"지식컨텐츠현황"
        },
        {
          index: 2,
          index01:"지식HTML 뷰어"
        },
      ],
      divGridNoAllocPage: 1,
      divGridNoAllocPageCount: 0,
      divGridNoAllocItemsPerPage: 100,
      divGridNoAllocTotalVisible: 10,
      divGridAllocDataText: [],
      divGridAllocPage: 1,
      divGridAllocPageCount: 0,
      divGridAllocItemsPerPage: 100,
      divGridAllocTotalVisible: 10,
      selectedDivGridAllocList:[],
      selectedDivGridNoAllocList:[],
      divGridAllocBtn: [
        {
          text: "버튼ID",
          value: "SCR_BTN_ID",
          align: "left",
          sortable: true,
        },
        {
          text: "버튼명",
          value: "SCR_BTN_NM",
          align: "left",
          sortable: true,
        }
      ],
      divGridNoAllocBtn:[
        {
          text: "버튼ID",
          value: "SCR_BTN_ID",
          align: "left",
          sortable: true,
        },
        {
          text: "버튼명",
          value: "SCR_BTN_NM",
          align: "left",
          sortable: true,
        }
      ],
      detailData: {},
      divGridAllocBtnDataText:[],
      divGridAllocBtnPage: 1,
      divGridAllocBtnPageCount: 0,
      divGridAllocBtnItemsPerPage: 100,
      divGridAllocBtnTotalVisible: 10,
      divGridNoAllocBtnDataText: [ ],
      divGridNoAllocBtnPage: 1,
      divGridNoAllocBtnPageCount: 0,
      divGridNoAllocBtnItemsPerPage: 100,
      divGridNoAllocBtnTotalVisible: 10,
      selectedDivGridAllocBtnList:[],
      selectedDivGridNoAllocBtnList:[],
      textareaRules: [(v) => v.length <= 200 || "Max 200 characters"],
      textareaValue: "200자 제한!",
    };
  },
  methods: {
    groupCodeInqire(){
      this.headers = this.initHeaders;
      this.URLData = "/api/setting/system/menu-author-manage/author-group-code/inqire";
      this.headers["SERVICE"] = "setting.system.menu-author-manage.author-group-code";
      this.headers["METHOD"] = "inqire";
      this.headers["ASYNC"] = false;
      this.result();
    },
    groupCodeInqireCallBack(response){
      let header = response.HEADER;
      let data = response.DATA;
      this.dropItems2 = data;
    },

    menuGroupInqire(){
      this.headers = this.initHeaders;
      this.URLData = "/api/setting/system/menu-author-manage/group/inqire";
      this.headers["SERVICE"] = "setting.system.menu-author-manage.group";
      this.headers["METHOD"] = "inqire";
      this.headers["ASYNC"] = false;

      this.result();
    },
    menuGroupInqireCallBack(response){
      let header = response.HEADER;
      let data = response.DATA;
      this.dropItems = data;
    },
    getListSel(item){
      this.selectedMenu = item;
      //this.detailData = JSON.parse(JSON.stringify(item));
      this.getDivGridNoAllocBtn(item);//미할당 버튼
      this.getDivGridAllocBtn(item);//할당 버튼
    },
    getDivGridNoAllocBtn(item){//미할당버튼
      this.headers = this.initHeaders;
      this.URLData = "/api/setting/system/menu-author-manage/un-asgn-button/inqire";
      this.headers["SERVICE"] = "setting.system.menu-author-manage.un-asgn-button";
      this.headers["METHOD"] = "inqire";
      this.headers["ASYNC"] = false;
      this.headers["GRID_ID"] = "divGridNoAllocBtn";

      this.sendData= {};
      this.sendData["MENU_ID"] = this.selectedMenu.MENU_ID;
      this.sendData["ATRT_GROUP_ID"] = this.atrtGroupId;
      this.result();
    },
    getDivGridAllocBtn(item){//할당버튼
      this.headers = this.initHeaders;
      this.URLData = "/api/setting/system/menu-author-manage/asgn-button/inqire";
      this.headers["SERVICE"] = "setting.system.menu-author-manage.asgn-button";
      this.headers["METHOD"] = "inqire";
      this.headers["ASYNC"] = false;
      this.headers["GRID_ID"] = "divGridAllocBtn";

      this.sendData= {};
      this.sendData["MENU_ID"] = this.selectedMenu.MENU_ID;
      this.sendData["ATRT_GROUP_ID"] = this.atrtGroupId;
      this.result();
    },
    getDivGridNoAllocBtnCallBack(response){
      let header = response.HEADER;
      let data = response.DATA;
      this.divGridNoAllocBtnDataText = data;

      this.detailData = [];
      let idx = 1;
      let dataText = this.divGridNoAllocBtnDataText;
      for (let i in dataText) {
        this.divGridNoAllocBtnDataText[i]["index"] = idx++;
      }
    },
    getDivGridAllocBtnCallBack(response){
      let header = response.HEADER;
      let data = response.DATA;
      this.divGridAllocBtnDataText = data;
      this.detailData = [];
      let idx = 1;
      let dataText = this.divGridAllocBtnDataText;
      for (let i in dataText) {
        this.divGridAllocBtnDataText[i]["index"] = idx++;
      }
    },
    moveUp() {
      let btnGrid1_selected = this.selectedDivGridNoAllocBtnList;  // 미할당버튼 체크박스
      let btnGrid1 = this.divGridNoAllocBtnDataText;     // 미할당버튼
      let btnGgrid2 = this.divGridAllocBtnDataText;       // 할당버튼
      if (btnGrid1_selected.length > 0) {
        for(var i in btnGrid1_selected){
          btnGrid1.splice(btnGrid1.indexOf(btnGrid1_selected[i]) , 1);
          btnGgrid2.push(btnGrid1_selected[i]);
        }
        this.selectedDivGridNoAllocBtnList = [];
      } else {
        this.common_alert("미할당 버튼이 선택되지 않았습니다.","error");
      }
    },
    moveDown(){
      let btnGrid2_selected = this.selectedDivGridAllocBtnList;   // 할당버튼 체크박스
      let btnGrid1 = this.divGridNoAllocBtnDataText;     // 미할당버튼
      let btnGgrid2 = this.divGridAllocBtnDataText;       // 할당버튼
      if (btnGrid2_selected.length > 0) {
        for(var i in btnGrid2_selected) {
          btnGgrid2.splice(btnGgrid2.indexOf(btnGrid2_selected[i]), 1);
          btnGrid1.push(btnGrid2_selected[i]);
        }
        this.selectedDivGridAllocBtnList = [];
      } else {
        this.common_alert("할당 버튼이 선택되지 않았습니다.","error");
      }
    },
    submitBtnGrid1(){//저장
      this.headers = this.initHeaders;
      this.URLData = "/api/setting/system/menu-author-manage/button-author/regist";
      this.headers["SERVICE"] = "setting.system.menu-author-manage.button-author";
      this.headers["METHOD"] = "regist";
      this.headers["ASYNC"] = false;
      this.headers["SUBMIT"] ="getlistsel";
      let submitList = [];
      let headersObj = {
        DATA_FLAG:"D",
        ATRT_GROUP_ID:this.atrtGroupId,
        MENU_ID :this.selectedMenu.MENU_ID,
      }
      submitList.push(headersObj);
      for(let i in this.divGridAllocBtnDataText){
        let obj = {
          divGridAlloc_CHECKBOX:'0',
          SCR_BTN_ID: this.divGridAllocBtnDataText[i].SCR_BTN_ID,
          SCR_BTN_NM: this.divGridAllocBtnDataText[i].SCR_BTN_NM,
          BTN_TYPE: this.divGridAllocBtnDataText[i].BTN_TYPE,
          BTN_ID: this.divGridAllocBtnDataText[i].BTN_ID,
          ATRT_GROUP_ID: this.atrtGroupId,
          MENU_ID: this.divGridAllocBtnDataText[i].MENU_ID,
          REGR_ID: this.$store.getters['userStore/GE_USER_ROLE'].userId,
          DATA_FLAG:"I",
        };
        submitList.push(obj);
      }
      this.sendData  = {
        list:submitList
      }
      this.result();
    },
    submitBtnGridCallBack(response){//
      this.common_alert("정상처리 되었습니다.","done");
      this.getListSel(this.selectedMenu);
    },
    getListOrNot(){
      if(this.mixin_isEmpty(this.menuGroup)) {
        this.common_alert('메뉴그룹을 선택해주세요.', 'error');
      }else if(this.mixin_isEmpty(this.atrtGroupId)){
        this.common_alert('권한그룹을 선택해주세요.', 'error');
      } else{
        this.getList();
      }
    },
    getList(){
      this.getDivGridNoAlloc();//미할당 사용자
      this.getDivGridAlloc();//할당사용자
    },
    getDivGridNoAlloc(){
      this.headers = this.initHeaders;
      this.URLData = "/api/setting/system/menu-author-manage/un-asgn-menu/inqire";
      this.headers["METHOD"] = "inqire";
      this.headers["SERVICE"] = "setting.system.menu-author-manage.un-asgn-menu";
      this.headers["ASYNC"] = false;
      this.headers["GRID_ID"] = "divGridNoAlloc";

      this.sendData= {};
      this.sendData["MENU_GROUP"] = this.menuGroup;
      this.sendData["ATRT_GROUP_ID"] = this.atrtGroupId;
      this.result();
    },
    getDivGridAlloc(){
      this.headers = this.initHeaders;
      this.URLData = "/api/setting/system/menu-author-manage/asgn-menu/inqire";
      this.headers["SERVICE"] = "setting.system.menu-author-manage.asgn-menu";
      this.headers["METHOD"] = "inqire";
      this.headers["ASYNC"] = false;
      this.headers["GRID_ID"] = "divGridAlloc";

      this.sendData= {};
      this.sendData["MENU_GROUP"] = this.menuGroup;
      this.sendData["ATRT_GROUP_ID"] = this.atrtGroupId;
      this.result();
    },
    getDivGridNoAllocCallBack(response){
      let header = response.HEADER;
      let data = response.DATA;
      this.divGridNoAllocDataText = data;
      let idx = 1;
      let dataText = this.divGridNoAllocDataText;
      for (let i in dataText) {
        this.divGridNoAllocDataText[i]["index"] = idx++;
      }
      this.selectedDivGridNoAllocList = [];
      this.divGridAllocBtnDataText = [];
      this.divGridNoAllocBtnDataText = [];
      this.detailData = [];
    },
    getDivGridAllocCallBack(response){
      let header = response.HEADER;
      let data = response.DATA;
      this.divGridAllocDataText = data;
      let idx = 1;
      let dataText = this.divGridAllocDataText;
      for (let i in dataText) {
        this.divGridAllocDataText[i]["index"] = idx++;
      }
      this.selectedDivGridAllocList =[];
      this.divGridAllocBtnDataText = [];
      this.divGridNoAllocBtnDataText = [];
      this.selectedMenu = '';
    },
    moveRight() {
      let grid1_selected = this.selectedDivGridNoAllocList;  // 미할당 사용 체크박스
      let grid1 = this.divGridNoAllocDataText;     // 미할당사용자 그리드
      let grid2 = this.divGridAllocDataText;       // 할당사용자 그리드
      if (grid1_selected.length > 0) {
        for(var i in grid1_selected){
          grid1.splice(grid1.indexOf(grid1_selected[i]) , 1);
          grid2.push(grid1_selected[i]);
        }
        this.selectedDivGridNoAllocList = [];
      } else {
        this.common_alert("미할당 메뉴가 선택되지 않았습니다.","error");
      }
    },
    moveLeft(){
      let grid2_selected = this.selectedDivGridAllocList;   // 할당 사용 체크박스
      let grid1 = this.divGridNoAllocDataText;     // 미할당사용자 그리드
      let grid2 = this.divGridAllocDataText;       // 할당사용자 그리드
      if (grid2_selected.length > 0) {
        for(var i in grid2_selected) {
          grid2.splice(grid2.indexOf(grid2_selected[i]), 1);
          grid1.push(grid2_selected[i]);
        }
        this.selectedDivGridAllocList = [];
      } else {
        this.common_alert("할당 메뉴가 선택되지 않았습니다.","error");
      }
    },
    submitGrid1(){//저장
      this.headers = this.initHeaders;
      this.URLData = "/api/setting/system/menu-author-manage/regist";
      this.headers["SERVICE"] = "setting.system.menu-author-manage";
      this.headers["METHOD"] = "regist";
      this.headers["ASYNC"] = false;
      this.headers["SUBMIT"] ="getlist";
      let submitList = [];
      let headersObj = {
        DATA_FLAG:"D",
        MENU_GROUP:this.menuGroup,
        ATRT_GROUP_ID:this.atrtGroupId,
      }
      submitList.push(headersObj);
      for(let i in this.divGridAllocDataText){
        let obj = {
          divGridAlloc_CHECKBOX:'0',
          LOWRNK_MENU_ID: "",
          ATRT_GROUP_ID: this.atrtGroupId,
          ATRT_GROUP_NM: this.divGridAllocDataText[i].ATRT_GROUP_NM,//권한그룹명
          MENU_NM: this.divGridAllocDataText[i].MENU_NM,//메뉴명
          MENU_ID: this.divGridAllocDataText[i].MENU_ID,
          REGR_DEPT_CD: 'x',
          REGR_ID: this.$store.getters['userStore/GE_USER_ROLE'].userId,
          PROC_ID: this.$store.getters['userStore/GE_USER_ROLE'].userId,
          DATA_FLAG:"I",
        };
        submitList.push(obj);
      }
      this.sendData  = {
        list:submitList
      }
      this.result();
    },
    submitGridCallBack(response){//
      this.common_alert("정상처리 되었습니다.","done");
      this.getList();
    },

    getGrid1_ListSel(item){
      this.detailData = JSON.parse(JSON.stringify(item));
    },
    isActiveRow1(item){
      return item.MENU_ID== this.detailData.MENU_ID? 'active':'';
    },
    isActiveRow2(item){
      return item.BTN_ID== this.detailData.BTN_ID? 'active':'';
    },
    isActiveRow3(item){
      return item.MENU_ID== this.selectedMenu.MENU_ID? 'active':'';
    },
    startDate(e) {
      this.dates[0] = e;
    },
    endDate(e) {
      this.dates[1] = e;
    },
    showDialog(type) {
      this[`dialog${type}`] = true;
    },
    hideDialog(type) {
      this[`dialog${type}`] = false;
    },
    submitDialog(type) {
      this[`dialog${type}`] = false;
    },

    async result(requestData){
      let head='';
      let dataa='';
      //결과값을 보여주는 부분 -> 실제 사용 시 dataa의 value를 사용
      //api 호출 부분
      await api.post(this.URLData,   //api url입력
          //await axios.post('https://local.hkpalette.com:8443/'+this.URLData,{
          this.sendData
          , //api에서 사용될 data 입력
          {head: this.headers
          }) //api에 로그를 남기기위한 값입력 (필수) (SERVICE, METHOD, TYPE)
          .then((response) => {
            // head = JSON.stringify(response.data.HEADER);
            //dataa = JSON.stringify(response.data.DATA);
            if(typeof(response.data) === "string"){
              let responseData = JSON.parse(response.data.replaceAll("\n", ""));
              this.$store.commit("alertStore/openAlertDialog", {
                alertDialogToggle: true,
                msg: responseData.HEADER.ERROR_MSG,
                iconClass: "svg-error-lg",
                type: "default",
              });
              return;
            }
            if(response.data.HEADER.METHOD == "inqire" &&response.data.HEADER.GRID_ID =="divGridNoAlloc"){
              this.getDivGridNoAllocCallBack(response.data);
            }else if(response.data.HEADER.METHOD == "inqire" &&response.data.HEADER.GRID_ID =="divGridAlloc") {
              this.getDivGridAllocCallBack(response.data);
            }else if(response.data.HEADER.METHOD == "regist" &&response.data.HEADER.SUBMIT == "getlist") {
              this.submitGridCallBack(response.data);
            }else if(response.data.HEADER.METHOD == "regist" &&response.data.HEADER.SUBMIT == "getlistsel") {
              this.submitBtnGridCallBack(response.data);
            }else if(response.data.HEADER.METHOD == "inqire" &&response.data.HEADER.GRID_ID =="divGridAllocBtn") {
              this.getDivGridAllocBtnCallBack(response.data);
            }else if(response.data.HEADER.METHOD == "inqire" &&response.data.HEADER.GRID_ID =="divGridNoAllocBtn") {
              this.getDivGridNoAllocBtnCallBack(response.data);
            }else if(response.data.HEADER.METHOD == "inqire" &&response.data.HEADER.SERVICE =="setting.system.menu-author-manage.group") {
              this.menuGroupInqireCallBack(response.data);
            }else if(response.data.HEADER.METHOD == "inqire" &&response.data.HEADER.SERVICE =="setting.system.menu-author-manage.author-group-code") {
              this.groupCodeInqireCallBack(response.data);
            }
          }) //api 호출 성공 이후 수행
          .catch((err) => {
            this.common_alert("시스템 장애가 일어났습니다.<br>잠시후에 다시 시도해주세요.", "error");
          }) //api호출 에러 작업 수행
      this.HEADERResult = head;
      this.DATAResult = dataa;
      //결과값 보여주기
    }
  },
  mounted() {
    this.menuGroupInqire();
    this.groupCodeInqire();
  },

  computed: {
    dateRangeText() {
      var newStartDate = this.dates[0];
      var newEndDate = this.dates[1];
      return newStartDate + " ~ " + newEndDate;
    },
    initHeaders(){//getDivGridNoAlloc
      return this.headers = {
        "SERVICE": 'setting.system.menu-author-manage.un-asgn-menu',
        "METHOD" : "",
        "TYPE" :'BIZ_SERVICE',
        "GRID_ID":"",

      };
    },
  },
};
</script>

<style>

</style>
